import { PercentPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { PatientInvoiceablesBufferInput } from '@features/patient-invoiceables-buffer-input/patient-invoiceables-buffer-input.component';

import { CardComponent } from '@shared/components/card/card.component';

import { injectInvestigatorForecastMetadata } from './api/investigator-metadata.api';
import { ReforecastStepsComponent } from './components/reforecast-steps/reforecast-steps.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardComponent, PercentPipe, PatientInvoiceablesBufferInput, ReforecastStepsComponent],
  selector: 'aux-investigator-forecast-settings',
  styleUrls: ['./investigator-settings.component.scss'],
  templateUrl: './investigator-settings.component.html',
})
export class InvestigatorForecastSettingsComponent {
  metadata = injectInvestigatorForecastMetadata();

  patientInvoiceablesToDate = computed(
    () => this.metadata.data()?.patient_invoiceable_percentage || 0
  );
}
